module.exports = __webpack_public_path__ + "static/media/desarrollo4.9843dfb6.png";